module.exports = __webpack_public_path__ + "static/media/poll-h.c0c6718c.svg";